module.exports = new __parcel__URL__("machines_laser_cannon_level_3.47cc4aa5.png").toString();